export const ADD_ALERT = 'alerts/ADD_ALERT';
export const REMOVE_ALERT = 'alerts/REMOVE_ALERT';
export const SHOW_ALERT = 'alerts/SHOW_ALERT';
export const CLEAR_ALERTS = 'alerts/CLEAR_ALERTS';
